// Default export with all functions
import {
	legalMedicalDisabilityCompensation,
	additionalMedicalDisabilityCompensation,
} from "./medical-disability";
import {
	legalOccupationalDisabilityCompensation,
	additionalOccupationalDisabilityCompensation,
} from "./occupational-disability";
import {
	legalBaseLifeInsuranceCompensation,
	legalChildSupplementLifeInsuranceCompensation,
	legalFuneralAllowance,
	legalLifeInsuranceCompensation,
	leisureAccidentDeath,
	leisureAccidentDeathChildSupplement,
	leisureAccidentDeathFuneralAllowance,
	leisureAccidentDeathBaseCoverage,
	funeralAllowance,
} from "./life-insurance";
import {
	groupLifeHTA,
	groupLifeIntervals,
	groupLifeAnnualSalary,
	groupLifeBaseCoverage,
	groupLifeChildSupplement,
	groupLifeGradualReduction,
	groupLifeAnnualSalaryAboveXG,
} from "./group-life";
import {
	dependentsAllowanceBaseCoverage,
	dependentsAllowanceAnnualSalary,
} from "./dependents-allowance";
import { disabilityCapitalCompensation } from "./disability-capital";
import {
	collectiveAccidentDeathCompensation,
	collectiveAccidentInvalidityCompensation,
} from "./collective-accident";

export default {
	legalMedicalDisabilityCompensation,
	additionalMedicalDisabilityCompensation,
	legalOccupationalDisabilityCompensation,
	additionalOccupationalDisabilityCompensation,
	legalBaseLifeInsuranceCompensation,
	legalChildSupplementLifeInsuranceCompensation,
	legalFuneralAllowance,
	funeralAllowance,
	legalLifeInsuranceCompensation,
	leisureAccidentDeath,
	leisureAccidentDeathChildSupplement,
	leisureAccidentDeathFuneralAllowance,
	leisureAccidentDeathBaseCoverage,
	dependentsAllowanceBaseCoverage,
	dependentsAllowanceAnnualSalary,
	groupLifeHTA,
	groupLifeIntervals,
	groupLifeAnnualSalary,
	groupLifeBaseCoverage,
	groupLifeChildSupplement,
	groupLifeGradualReduction,
	groupLifeAnnualSalaryAboveXG,
	disabilityCapitalCompensation,
	collectiveAccidentInvalidityCompensation,
	collectiveAccidentDeathCompensation,
};
